import { z } from "zod";

import {
	country,
	industry,
	interestedIn,
	language,
	province,
	state,
} from "@rootreeweb/ns-helper";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";
import BaseForm from "./KeepInTouch.js";
import { consentTextEN, consentTime } from "./shared.js";

const { submissionOptions } = BaseForm;
const schema = z.object({
	"First Name": z.string(),
	"Last Name": z.string(),
	Email: z.string().email(),
	Company: z.string(),
	Phone: z.string().optional(),
	URL: z.string().optional(),
	Country: country.default("Canada"),
	State: state,
	Province: province,
	"Interested In": interestedIn,
	Language: language.default("English (CA)"),
	Industry: industry.default("Other"),
	Notes: z
		.string()
		.optional()
		.describe(
			createCustomSettings({
				label: "Notes",
				textArea: true,
			}),
		),
	"Consent Text": consentTextEN,
	"Consent Time": consentTime,
});

const keepInTouch: FormDefinition<typeof schema.shape> = {
	signature: "86cf73b16607aefe52002f6666eefb9c8d34927f1af5dcf552fbedb0d97eb3c7",
	formID: "client-keep-in-touch",
	schema,
	submissionOptions,
	formOptions: {
		redirect: "https://rootree.ca/newsletter/thank-you/",
	},
};
export default keepInTouch;
